import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import MainBusinessPartnersBlockData from '../../../Models/Content/BusinessPartnersMainBlockData';
import MainBusinessPartners from './MainBusinessPartners';

export default class BusinessPartnersMainBlock extends EpiComponent<MainBusinessPartnersBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <MainBusinessPartners iContent={this.props.data} context={this.getContext()} />;
  }
}
